export default __webpack_public_path__ + "static/media/ftt_num_bg.0fd4c613.svg";